export default __webpack_public_path__ + "static/media/appointment_blank.519e76cd.png";